import * as environments from 'src/environments.json';
import at from '../../shared/utils/at';
const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const USE_CASE_URL = 'customer-contracts';

const downloadHeadquarterContractListExcel = ({ companyHeadquarterId }) => {
  const url = `${
    env.api.url
  }/${USE_CASE_URL}/download/excel?companyHeadquarterId=${companyHeadquarterId}&t=${at(
    localStorage.accessToken
  )}`;

  window.location = url;
};

export default downloadHeadquarterContractListExcel;
